<template>
    <section id="robotics_industry_content">

        <div class="container">

            <div class="row" id="first_row">

                <!-- In Small Screen -->
                <nav aria-label="breadcrumb" class="mt-4 d-block d-lg-none">
                    <ol class="breadcrumb mb-0">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'service' }" class="text-reset">الخدمات</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            <router-link :to="{ name: 'robotics_industry' }" class="text-reset">صناعة الإلكترونيات
                                والروبوتات</router-link>
                        </li>
                    </ol>
                </nav>

                <div class="col-12 col-lg-6 mt-3 mt-lg-4 order-2 order-lg-1">

                    <div class="col_one_content d-flex flex-column justify-content-start w-100 h-100">

                        <nav aria-label="breadcrumb" class="d-none d-lg-block">
                            <ol class="breadcrumb mb-0">
                                <li class="breadcrumb-item">
                                    <router-link :to="{ name: 'service' }" class="text-reset">الخدمات</router-link>
                                </li>
                                <li class="breadcrumb-item active" aria-current="page">
                                    <router-link :to="{ name: 'robotics_industry' }" class="text-reset">صناعة الإلكترونيات
                                        والروبوتات</router-link>
                                </li>
                            </ol>
                        </nav>

                        <p>قيادة مجال صناعة الروبوتات والمكونات التقنية المتقدمة بالتعاون مع منظومة التصنيع للمساهمة في
                            توطين الصناعات المتقدمة ونقل التكنولوجيا ودعم سلاسل الإمداد.</p>

                        <h5 class="mt-3">ماذا نقدم لك؟</h5>

                        <ul class="mb-0">
                            <li>نقدم تجربة مبسطة للنماذج الأولية للروبوتات والمكونات التقنية . كما نوفر متجر متخصص في بيع
                                المنتجات مع عرض الأسعار المناسبة ، جنبًا إلى جنب مع تعليقات تحليل السوق المالي. يمكنك بسهولة
                                إدارة طلباتك وتتبعها من خلال متجر روبوتيرا.</li>
                        </ul>

                        <a class="btn mt-3" id="robotera_btn" href="https://robotera.com.sa/dev/#/"
                            role="button">متجر روبوتيرا</a>

                    </div>

                </div>

                <div
                    class="col-12 col-lg-6 mt-3 mt-lg-4 d-flex justify-content-center align-items-start order-1 order-lg-2">

                    <div class="col_two_content">
                        <div class="img_wrapper">
                            <img src="@/assets/images/services/robotics_industry_img.webp" alt="">
                        </div>
                    </div>

                </div>

            </div>

            <div class="row mb-3 mb-lg-0" id="second_row">

                <h5 class="mt-3 mb-0">تعرف على أنواع الروبوتات</h5>

                <div class="col-6 col-lg-3 mt-3">

                    <div class="col_three_content w-100 h-100">

                        <!-- <router-link :to="{ name: '' }"> -->
                            <div class="card p-3">
                                <div class="image_wrapper">
                                    <img class="card-img-top" src="@/assets/images/services/education_robots.webp" alt="" />
                                </div>
                                <div class="card-body">
                                    <h5 class="card-title text-center">الروبوتات التعليمية</h5>
                                </div>
                            </div>
                        <!-- </router-link> -->

                    </div>

                </div>

                <div class="col-6 col-lg-3 mt-3">

                    <div class="col_three_content w-100 h-100">

                        <!-- <router-link :to="{ name: '' }"> -->
                            <div class="card p-3">
                                <div class="image_wrapper">
                                    <img class="card-img-top" src="@/assets/images/services/sport_ropots.webp" alt="" />
                                </div>
                                <div class="card-body">
                                    <h5 class="card-title text-center">الروبوتات الرياضية</h5>
                                </div>
                            </div>
                        <!-- </router-link> -->

                    </div>

                </div>

                <div class="col-6 col-lg-3 mt-3">

                    <div class="col_three_content w-100 h-100">

                        <!-- <router-link :to="{ name: '' }"> -->
                            <div class="card p-3">
                                <div class="image_wrapper">
                                    <img class="card-img-top" src="@/assets/images/services/service_robots.webp" alt="" />
                                </div>
                                <div class="card-body">
                                    <h5 class="card-title text-center">الروبوتات الخدمية</h5>
                                </div>
                            </div>
                        <!-- </router-link> -->

                    </div>

                </div>

                <div class="col-6 col-lg-3 mt-3">

                    <div class="col_three_content w-100 h-100">

                        <!-- <router-link :to="{ name: '' }"> -->
                            <div class="card p-3">
                                <div class="image_wrapper">
                                    <img class="card-img-top" src="@/assets/images/services/ai_technologies.webp" alt="" />
                                </div>
                                <div class="card-body">
                                    <h5 class="card-title text-center">تقنيات الذكاء الإصطناعي</h5>
                                </div>
                            </div>
                        <!-- </router-link> -->

                    </div>

                </div>

            </div>

        </div>

    </section>
</template>

<script>
export default {
    name: 'RoboticsIndustry',
}
</script>

<style lang="scss" scoped>
#robotics_industry_content {

    min-height: 100vh;

    margin-top: 72px;

    @include breakpoints(x-small) {
        margin-top: 86px;
    }

    @include breakpoints(small) {
        margin-top: 86px;
    }

    @include breakpoints(medium) {
        margin-top: 86px;
    }

    .container {

        #first_row {

            nav {
                .breadcrumb {

                    li:first-of-type {
                        font-size: 16px;
                        line-height: 180%;
                        background: $Linear-Blue;
                        background-clip: text;
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                    }

                    li:nth-of-type(2n) {
                        font-family: 'FFShamelFamily-Bold';
                        font-size: 18px;
                        line-height: 180%;
                        color: $Green;
                    }

                }

                .breadcrumb-item::before {
                    float: right;
                    margin-left: 8px;
                    background: $Linear-Blue;
                    background-clip: text;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
            }

            .col_one_content {

                p {
                    color: $White;
                    font-size: 16px;
                    line-height: 180%;
                    text-align: justify;
                    margin-bottom: 0;
                }

                h5 {
                    font-family: 'FFShamelFamily-Bold';
                    font-size: 16px;
                    line-height: 156%;
                    color: $Yellow;
                }

                ul {
                    color: $White;
                    font-size: 16px;
                    line-height: 180%;
                    padding-right: 15px;
                    padding-left: 0px;
                    text-align: justify;

                    li::marker {
                        color: $Yellow;
                    }
                }

                #robotera_btn{
                    width:fit-content;

                    padding: 6px 8px;

                    color: $White;
                    font-size: 16px;
                    line-height: 180%;

                    border-radius: 8px;

                    background: $Linear-Blue;
                    background-clip: padding-box;
                    -webkit-background-clip: padding-box;
                    -webkit-text-fill-color: $White;
                }

            }

            // https://stackoverflow.com/questions/31854185/how-to-add-border-in-my-clip-path-polygon-css-style
            .col_two_content {

                position: relative;

                width: 636px;
                height: 426px;

                @include breakpoints(x-small) {
                    width: 351px;
                    height: 235px;
                }

                @include breakpoints(small) {
                    width: 516px;
                    height: 345px;
                }

                @include breakpoints(medium) {
                    width: 696px;
                    height: 466px;
                }

                @include breakpoints(large) {
                    width: 456px;
                    height: 305px;
                }

                @include breakpoints(x-Large) {
                    width: 546px;
                    height: 366px;
                }

                background: $Green;
                box-sizing: border-box;

                // https://www.cssportal.com/css-clip-path-generator/
                // CSS Vendor Prefixes
                -webkit-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -moz-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -o-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -ms-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);

                .img_wrapper {

                    position: absolute;
                    top: 1px;
                    left: 1px;

                    width: 634px;
                    height: 424px;

                    @include breakpoints(x-small) {
                        width: 349px;
                        height: 233px;
                    }

                    @include breakpoints(small) {
                        width: 514px;
                        height: 343px;
                    }

                    @include breakpoints(medium) {
                        width: 694px;
                        height: 464px;
                    }

                    @include breakpoints(large) {
                        width: 454px;
                        height: 303px;
                    }

                    @include breakpoints(x-Large) {
                        width: 544px;
                        height: 364px;
                    }

                    // https://www.cssportal.com/css-clip-path-generator/
                    // CSS Vendor Prefixes
                    -webkit-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                    -moz-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                    -o-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                    -ms-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                    clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);

                    // border: solid 2px $Green;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        opacity: 0.9;
                    }

                    img:hover {
                        opacity: 1;
                        -webkit-transition: opacity 0.5s linear 0.2s;
                        -moz-transition: opacity 0.5s linear 0.2s;
                        transition: opacity 0.5s linear 0.2s;
                    }

                }

            }

        }

        #second_row {

            h5 {

                font-family: 'FFShamelFamily-Bold';
                font-size: 16px;
                line-height: 156%;
                color: $Yellow;
            }

            .col_three_content {

                .card {

                    background: $Dark-Green;

                    // CSS Vendor Prefixes
                    -webkit-clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);
                    -moz-clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);
                    -o-clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);
                    -ms-clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);
                    clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);

                    height: 200px;

                    @include breakpoints(x-small) {
                        height: 225px;
                    }

                    .image_wrapper {
                        width: 60%;
                        height: 80px;
                        margin: auto;

                        @include breakpoints(x-small) {
                            width: 80%;
                        }

                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: contain;
                        }
                    }

                    .card-body {

                        h5 {
                            font-family: 'FFShamelFamily-Bold';
                            font-size: 16px;
                            line-height: 156%;
                            color: $White;
                        }

                    }


                }

                .card:hover {
                    background: $Linear-Blue;
                }

            }

        }

    }

}
</style>